/**
 * Подсказка «?» к неочевидной функции (шаг 11): 1–2 предложения — что делает функция и когда ей пользоваться.
 * Открывается по наведению и с клавиатуры (фокус на кнопке «?»), закрывается уходом курсора, потерей фокуса или Esc.
 * Тексты — в `lib/help.ts`, чтобы одна и та же функция объяснялась везде одинаково.
 */

import { useId, useState } from 'react';
import type { KeyboardEvent } from 'react';

interface HelpTipProps {
    text: string;
    /** Что поясняет подсказка — для экранного диктора («Подсказка: продление срока»). */
    label: string;
    /** К какому краю кнопки прижать текст: у правого края экрана — `end`. */
    align?: 'start' | 'end';
}

export function HelpTip({ text, label, align = 'start' }: HelpTipProps) {
    const id = useId();
    const [hidden, setHidden] = useState(false);
    const onKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
        if (event.key === 'Escape') {
            event.stopPropagation();
            setHidden(true);
        }
    };
    return (
        <span className={'help-tip' + (align === 'end' ? ' help-tip-end' : '') + (hidden ? ' help-tip-hidden' : '')} onMouseLeave={() => setHidden(false)}>
            <button
                type="button"
                className="help-tip-btn"
                aria-label={'Подсказка: ' + label}
                aria-describedby={id}
                onKeyDown={onKeyDown}
                onBlur={() => setHidden(false)}
                onClick={(event) => event.stopPropagation()}
            >
                ?
            </button>
            <span role="tooltip" id={id} className="help-tip-text">
                {text}
            </span>
        </span>
    );
}
